import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickStatsWidget = ({ stats }) => {
  const getIconForStat = (type) => {
    const icons = {
      totalPoints: 'Award',
      predictions: 'Target',
      tournaments: 'Trophy',
      accuracy: 'TrendingUp'
    };
    return icons?.[type] || 'Activity';
  };

  const getColorForStat = (type) => {
    const colors = {
      totalPoints: 'var(--color-primary)',
      predictions: 'var(--color-accent)',
      tournaments: 'var(--color-secondary)',
      accuracy: 'var(--color-success)'
    };
    return colors?.[type] || 'var(--color-primary)';
  };

  const formatValue = (value, type) => {
    if (type === 'accuracy') {
      return `${value}%`;
    }
    return value?.toLocaleString('en-US');
  };

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 lg:gap-6">
      {stats?.map((stat) => (
        <div
          key={stat?.type}
          className="bg-card rounded-lg shadow-elevation-sm p-4 md:p-5 lg:p-6 transition-smooth hover:shadow-elevation-md"
        >
          <div className="flex items-start justify-between mb-3">
            <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${getColorForStat(stat?.type)}15` }}>
              <Icon name={getIconForStat(stat?.type)} size={20} color={getColorForStat(stat?.type)} />
            </div>
            {stat?.change && (
              <div className={`flex items-center gap-1 text-xs ${stat?.change > 0 ? 'text-success' : 'text-error'}`}>
                <Icon name={stat?.change > 0 ? 'TrendingUp' : 'TrendingDown'} size={14} />
                <span>{Math.abs(stat?.change)}%</span>
              </div>
            )}
          </div>

          <div className="space-y-1">
            <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground">
              {formatValue(stat?.value, stat?.type)}
            </h3>
            <p className="text-sm md:text-base text-muted-foreground">{stat?.label}</p>
          </div>

          {stat?.progress !== undefined && (
            <div className="mt-3">
              <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                <div
                  className="h-full rounded-full transition-all duration-500"
                  style={{
                    width: `${stat?.progress}%`,
                    backgroundColor: getColorForStat(stat?.type)
                  }}
                />
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default QuickStatsWidget;